/**
 * SP-3a — build the ordered two-sided intent conversation for one spine.
 *
 * Includes user turns, foreman `peer_response`s, AND canonical-asst member
 * turns (rendered as role 'foreman' — approach B mirrors their text into the
 * panel while the canvas node stays for provenance). Excludes the spine-root
 * marker. Order follows the source message array (server-canonical order).
 */
import type { IntentTurn } from '../types';

export type { IntentTurn } from '../types';

type Msg = { id: string; role: string; content?: string; timestamp?: any; metadata?: any };

export function buildIntentThread(
  messages: Msg[],
  members: Map<string, string>,
  rootId: string,
): IntentTurn[] {
  const out: IntentTurn[] = [];
  for (const m of messages) {
    if (members.get(m.id) !== rootId) continue;
    if (m.metadata?.is_spine_root === true) continue;
    if (m.role !== 'user' && m.role !== 'assistant') continue;
    out.push({
      messageId: m.id,
      role: m.role === 'user' ? 'user' : 'foreman',
      content: m.content ?? '',
      personaId: m.metadata?.persona_id ?? null,
      timestamp: m.timestamp,
    });
  }
  return out;
}
